
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/recycle",
      function () {
        return require("private-next-pages/article/recycle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/recycle"])
      });
    }
  